var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemicalInjectionPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.188 245.011H211.81V340.913H389.188V245.011Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.102 156.24H278.585V165.189H323.102V156.24Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.586 160.714H265.351V169.663H335.586V160.714Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.543 339.911C349.549 339.911 389.277 300.183 389.277 251.177C389.277 202.17 349.549 162.443 300.543 162.443C251.537 162.443 211.809 202.17 211.809 251.177C211.809 300.183 251.537 339.911 300.543 339.911Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.543 338.106C348.553 338.106 387.472 299.187 387.472 251.177C387.472 203.167 348.553 164.248 300.543 164.248C252.533 164.248 213.614 203.167 213.614 251.177C213.614 299.187 252.533 338.106 300.543 338.106Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M319.298 340.913H281.789V164.33C281.789 164.33 288.918 161.917 300.649 161.917C311.177 161.917 319.298 164.33 319.298 164.33V340.913Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.567 340.913H292.723V162.822C292.723 162.822 295.925 162.218 301.192 162.218C305.92 162.218 309.567 162.822 309.567 162.822V340.913Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M305.456 167.456H292.622V169.462H305.456V167.456Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.345 184.1H292.622V186.106H301.345V184.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.456 199.941H292.622V201.947H305.456V199.941Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M305.456 231.827H292.622V233.833H305.456V231.827Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.456 265.114H292.622V267.12H305.456V265.114Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.456 298.001H292.622V300.007H305.456V298.001Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M305.456 332.892H292.622V334.898H305.456V332.892Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.345 215.783H292.622V217.789H301.345V215.783Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.345 248.268H292.622V250.274H301.345V248.268Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M301.345 280.252H292.622V282.258H301.345V280.252Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M301.345 314.844H292.622V316.85H301.345V314.844Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M323.629 144.684H277.307V156.239H323.629V144.684Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M277.909 144.321C277.909 144.321 285.805 138.907 300.644 138.907C315.081 138.907 323.705 143.72 323.705 143.72V144.685H277.909V144.321Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M244.295 340.913H226.649V407.088H244.295V340.913Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.643 326.676H241.438L264.899 341.514H205.643V326.676Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M374.639 340.913H356.591V407.088H374.639V340.913Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M356.59 366.404H244.295V374H356.59V366.404Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M395.443 326.676H359.649L336.187 341.514H395.443V326.676Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M323.604 145.348H277.282V155.575H323.604V145.348Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.497 144.446H281.491V156.478H283.497V144.446Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M299.894 144.446H297.888V156.478H299.894V144.446Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M316.589 144.446H314.583V156.478H316.589V144.446Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M603.577 192.467H594.577V391.949H603.577V192.467Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M658.861 192.064H538.544V29.6362L658.861 29.7412V192.064Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M655.853 189.056H541.552V32.644L655.853 32.745V189.056Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 25.6258L545.385 22.4678H567.042L570.1 25.6258V44.7258L567.042 47.7338H545.385L542.327 44.7258V25.6258Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 30.7118L570.1 30.6118",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 39.3349L570.1 39.2349",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 25.6258L630.512 22.4678H652.169L655.227 25.6258V44.7258L652.169 47.7338H630.512L627.453 44.7258V25.6258Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 30.7118L655.227 30.6118",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 39.3349L655.227 39.2349",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 25.6258L602.136 22.4678H623.793L626.852 25.6258V44.7258L623.793 47.7338H602.136L599.078 44.7258V25.6258Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 30.7118L626.852 30.6118",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 39.3349L626.852 39.2349",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 25.6258L573.76 22.4678H595.418L598.476 25.6258V44.7258L595.418 47.7338H573.76L570.702 44.7258V25.6258Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 30.7118L598.476 30.6118",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 39.3349L598.476 39.2349",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 51.4939L545.385 48.3359H567.042L570.1 51.4939V70.5939L567.042 73.6019H545.385L542.327 70.5939V51.4939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 56.58L570.1 56.48",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 65.203L570.1 65.103",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 51.4939L630.512 48.3359H652.169L655.227 51.4939V70.5939L652.169 73.6019H630.512L627.453 70.5939V51.4939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 56.58L655.227 56.48",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 65.203L655.227 65.103",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 51.4939L602.136 48.3359H623.793L626.852 51.4939V70.5939L623.793 73.6019H602.136L599.078 70.5939V51.4939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 56.58L626.852 56.48",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 65.203L626.852 65.103",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 51.4939L573.76 48.3359H595.418L598.476 51.4939V70.5939L595.418 73.6019H573.76L570.702 70.5939V51.4939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 56.58L598.476 56.48",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 65.203L598.476 65.103",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 103.309L545.385 100.151H567.042L570.1 103.309V122.41L567.042 125.418H545.385L542.327 122.41V103.309Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 108.394L570.1 108.295",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 117.018L570.1 116.918",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 103.309L630.512 100.151H652.169L655.227 103.309V122.41L652.169 125.418H630.512L627.453 122.41V103.309Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 108.394L655.227 108.295",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 117.018L655.227 116.918",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 103.309L602.136 100.151H623.793L626.852 103.309V122.41L623.793 125.418H602.136L599.078 122.41V103.309Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 108.394L626.852 108.295",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 117.018L626.852 116.918",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 103.309L573.76 100.151H595.418L598.476 103.309V122.41L595.418 125.418H573.76L570.702 122.41V103.309Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 108.394L598.476 108.295",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 117.018L598.476 116.918",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 140.076L545.385 136.918H567.042L570.1 140.076V159.177L567.042 162.185H545.385L542.327 159.177V140.076Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 145.162L570.1 145.062",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 153.785L570.1 153.685",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 140.076L630.512 136.918H652.169L655.227 140.076V159.177L652.169 162.185H630.512L627.453 159.177V140.076Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 145.162L655.227 145.062",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 153.785L655.227 153.685",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 140.076L602.136 136.918H623.793L626.852 140.076V159.177L623.793 162.185H602.136L599.078 159.177V140.076Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 145.162L626.852 145.062",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 153.785L626.852 153.685",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 140.076L573.76 136.918H595.418L598.476 140.076V159.177L595.418 162.185H573.76L570.702 159.177V140.076Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 145.162L598.476 145.062",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 153.785L598.476 153.685",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 77.3621L545.385 74.2041H567.042L570.1 77.3621V96.4631L567.042 99.4711H545.385L542.327 96.4631V77.3621Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 82.4481L570.1 82.3481",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 91.0712L570.1 90.9712",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 77.3621L630.512 74.2041H652.169L655.227 77.3621V96.4631L652.169 99.4711H630.512L627.453 96.4631V77.3621Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 82.4481L655.227 82.3481",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 91.0712L655.227 90.9712",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 77.3621L602.136 74.2041H623.793L626.852 77.3621V96.4631L623.793 99.4711H602.136L599.078 96.4631V77.3621Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 82.4481L626.852 82.3481",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 91.0712L626.852 90.9712",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 77.3621L573.76 74.2041H595.418L598.476 77.3621V96.4631L595.418 99.4711H573.76L570.702 96.4631V77.3621Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 82.4481L598.476 82.3481",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 91.0712L598.476 90.9712",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 165.944L545.385 162.786H567.042L570.1 165.944V185.045L567.042 188.053H545.385L542.327 185.045V165.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 171.03L570.1 170.93",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M542.327 179.653L570.1 179.553",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 165.944L630.512 162.786H652.169L655.227 165.944V185.045L652.169 188.053H630.512L627.453 185.045V165.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 171.03L655.227 170.93",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M627.453 179.653L655.227 179.553",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 165.944L602.136 162.786H623.793L626.852 165.944V185.045L623.793 188.053H602.136L599.078 185.045V165.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 171.03L626.852 170.93",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M599.078 179.653L626.852 179.553",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 165.944L573.76 162.786H595.418L598.476 165.944V185.045L595.418 188.053H573.76L570.702 185.045V165.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 171.03L598.476 170.93",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M570.702 179.653L598.476 179.553",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M641.552 223.613H556.127V312.647H641.552V223.613Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M642.153 217.697H555.525V223.713H642.153V217.697Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M556.127 249.28H641.552",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M633.243 270.498H563.533V312.208H633.243V270.498Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M633.243 267.691H563.533V270.498H633.243V267.691Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M632.679 266.2H564.098V267.779H632.679V266.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M612.488 257.464H585.19V260.271H612.488V257.464Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M612.488 254.657H585.19V257.464H612.488V254.657Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M574.326 262.132H571.73V266.157H574.326V262.132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M573.745 262.132H571.33V263.622H573.745V262.132Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M575.702 262.132H573.745V263.622H575.702V262.132Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M571.33 262.132H570.354V263.622H571.33V262.132Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M575.702 262.132H570.354V263.622H575.702V262.132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M578.418 265.172H567.589V266.074H578.418V265.172Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M625.436 261.914H622.84V265.939H625.436V261.914Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M624.855 261.914H622.44V263.404H624.855V261.914Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M626.812 261.914H624.855V263.404H626.812V261.914Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M622.44 261.914H621.464V263.404H622.44V261.914Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M626.812 261.914H621.464V263.404H626.812V261.914Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M629.553 265.172H618.724V266.074H629.553V265.172Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M555.977 229.406H554.338V234.31H555.977V229.406Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M643.068 229.406H641.429V234.31H643.068V229.406Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M643.068 303H641.429V307.904H643.068V303Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M555.977 303H554.338V307.904H555.977V303Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M604.643 346.73H593.374V391.949H604.643V346.73Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M641.43 391.446H440.901V407.087H641.43V391.446Z",
    fill: "white",
    stroke: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M452.042 346.73V334.898H494.955V346.73H505.784V391.446H440.901V346.73H452.042Z",
    fill: "white",
    stroke: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M486.934 303H460.208V334.898H486.934V303Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M489.67 303H487.006V334.898H489.67V303Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M460.208 303H457.544V334.898H460.208V303Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M473.605 313.855C475.078 313.855 476.275 315.048 476.275 316.525C476.275 317.997 475.078 319.195 473.605 319.195C472.129 319.195 470.935 317.998 470.935 316.525C470.935 315.048 472.129 313.855 473.605 313.855Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M474.248 304.617H461.944V311.234H474.248V304.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M463.304 305.108C463.611 305.108 463.859 305.356 463.859 305.663C463.859 305.97 463.61 306.218 463.304 306.218C462.997 306.218 462.749 305.969 462.749 305.663C462.749 305.356 462.998 305.108 463.304 305.108Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M472.973 309.476C473.28 309.476 473.528 309.725 473.528 310.031C473.528 310.338 473.279 310.586 472.973 310.586C472.666 310.586 472.418 310.337 472.418 310.031C472.418 309.724 472.667 309.476 472.973 309.476Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M488.338 298.635H483.525V303H488.338V298.635Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M484.628 290.479H462.582V302.999H484.628V290.479Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M494.956 310.383H490.143V322.415H494.956V310.383Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M456.956 310.383H452.143V322.415H456.956V310.383Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M435.9 310.632V322.414H443.42V318.855H451.962V314.043H443.42V310.632H435.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M511.008 310.503V322.285H503.488V318.726H494.946V313.914H503.488V310.503H511.008Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M437.798 317.547C438.435 317.547 438.951 317.031 438.951 316.394C438.951 315.757 438.435 315.241 437.798 315.241C437.161 315.241 436.645 315.757 436.645 316.394C436.645 317.031 437.161 317.547 437.798 317.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M435.9 312.223H423.63V320.565H435.9V312.223Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M462.582 293.589H484.628",
    stroke: "black",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M428.45 301.351H426.186V304.65H428.45V301.351Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M430.283 301.351H428.449V304.65H430.283V301.351Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M426.186 301.351H425.271V304.65H426.186V301.351Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M430.283 301.351H425.271V304.65H430.283V301.351Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M427.544 304.745H424.88V312.223H427.544V304.745Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M430.752 304.745H428.088V312.223H430.752V304.745Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M429.11 304.745H426.446V312.223H429.11V304.745Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M428.45 321.654H426.186V323.303H428.45V321.654Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M430.283 321.654H428.449V323.303H430.283V321.654Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M426.186 321.654H425.271V323.303H426.186V321.654Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M430.283 321.654H425.271V323.303H430.283V321.654Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M429.369 323.304H427.105V324.954H429.369V323.304Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M427.105 323.304H425.271V324.954H427.105V323.304Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M430.284 323.304H429.369V324.954H430.284V323.304Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M430.283 323.304H425.271V324.954H430.283V323.304Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M427.506 324.954H424.842V332.433H427.506V324.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M430.713 324.954H428.049V332.433H430.713V324.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M429.071 324.954H426.407V332.433H429.071V324.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M428.213 320.607H427.081V321.613H428.213V320.607Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M429.13 320.607H428.213V321.613H429.13V320.607Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M427.081 320.607H426.624V321.613H427.081V320.607Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M429.13 320.607H426.624V321.613H429.13V320.607Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M502.462 313.059H501.329V314.065H502.462V313.059Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M503.379 313.059H502.462V314.065H503.379V313.059Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M501.329 313.059H500.872V314.065H501.329V313.059Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M503.378 313.059H500.872V314.065H503.378V313.059Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M502.462 318.954H501.329V319.96H502.462V318.954Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M503.379 318.954H502.462V319.96H503.379V318.954Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M501.329 318.954H500.872V319.96H501.329V318.954Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M503.378 318.954H500.872V319.96H503.378V318.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M492.655 309.329H491.523V310.335H492.655V309.329Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M493.572 309.329H492.655V310.335H493.572V309.329Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M491.523 309.329H491.066V310.335H491.523V309.329Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M493.572 309.329H491.066V310.335H493.572V309.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M455.345 309.329H454.213V310.335H455.345V309.329Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M454.213 309.329H453.296V310.335H454.213V309.329Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M455.802 309.329H455.345V310.335H455.802V309.329Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M455.802 309.329H453.296V310.335H455.802V309.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M523.249 312.353H510.978V320.694H523.249V312.353Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M520.144 301.351H517.881V304.65H520.144V301.351Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M521.978 301.351H520.144V304.65H521.978V301.351Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M517.881 301.351H516.966V304.65H517.881V301.351Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M521.978 301.351H516.966V304.65H521.978V301.351Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M519.239 304.745H516.575V312.223H519.239V304.745Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M522.446 304.745H519.782V312.223H522.446V304.745Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M520.805 304.745H518.141V312.223H520.805V304.745Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M520.144 321.654H517.881V323.303H520.144V321.654Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M521.978 321.654H520.144V323.303H521.978V321.654Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M517.881 321.654H516.966V323.303H517.881V321.654Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M521.978 321.654H516.966V323.303H521.978V321.654Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M521.065 323.304H518.8V324.954H521.065V323.304Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M518.8 323.304H516.966V324.954H518.8V323.304Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M521.978 323.304H521.064V324.954H521.978V323.304Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M521.978 323.304H516.966V324.954H521.978V323.304Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M519.201 324.954H516.537V332.433H519.201V324.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M522.409 324.954H519.745V332.433H522.409V324.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M520.766 324.954H518.102V332.433H520.766V324.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M520.082 320.579H518.949V321.585H520.082V320.579Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M520.998 320.579H520.081V321.585H520.998V320.579Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M518.949 320.579H518.492V321.585H518.949V320.579Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M520.998 320.579H518.492V321.585H520.998V320.579Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M515.675 309.618H514.542V312.081H515.675V309.618Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M514.541 309.618H513.625V312.081H514.541V309.618Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M516.132 309.618H515.675V312.081H516.132V309.618Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M516.131 309.618H513.625V312.081H516.131V309.618Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M445.52 318.954H444.388V319.96H445.52V318.954Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M446.436 318.954H445.52V319.96H446.436V318.954Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M444.389 318.954H443.931V319.96H444.389V318.954Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M446.437 318.954H443.931V319.96H446.437V318.954Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M445.98 313.059H444.848V314.065H445.98V313.059Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M444.848 313.059H443.931V314.065H444.848V313.059Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M446.437 313.059H445.98V314.065H446.437V313.059Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M446.437 313.059H443.931V314.065H446.437V313.059Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M432.877 309.618H431.745V312.081H432.877V309.618Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M433.794 309.618H432.877V312.081H433.794V309.618Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M431.745 309.618H431.288V312.081H431.745V309.618Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M433.794 309.618H431.288V312.081H433.794V309.618Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M455.345 322.298H454.213V323.304H455.345V322.298Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M454.213 322.298H453.296V323.304H454.213V322.298Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M455.802 322.298H455.345V323.304H455.802V322.298Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M455.802 322.298H453.296V323.304H455.802V322.298Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M493.116 322.298H491.983V323.304H493.116V322.298Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M491.982 322.298H491.066V323.304H491.982V322.298Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M493.572 322.298H493.115V323.304H493.572V322.298Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M493.572 322.298H491.066V323.304H493.572V322.298Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M451.963 336.828H451.256V346.612H451.963V336.828Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M451.863 346.068H443.269V346.775H451.863V346.068Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M495.663 336.746H494.956V346.53H495.663V336.746Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M503.649 345.986H495.055V346.693H503.649V345.986Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M508.898 317.547C509.535 317.547 510.051 317.031 510.051 316.394C510.051 315.757 509.535 315.241 508.898 315.241C508.261 315.241 507.745 315.757 507.745 316.394C507.745 317.031 508.261 317.547 508.898 317.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M599.009 357.297C599.646 357.297 600.162 356.781 600.162 356.144C600.162 355.507 599.646 354.991 599.009 354.991C598.372 354.991 597.856 355.507 597.856 356.144C597.856 356.781 598.372 357.297 599.009 357.297Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M601.457 312.916H596.703V316.541H601.457V312.916Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M601.457 220.103H596.703V223.727H601.457V220.103Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M473.605 317.547C474.242 317.547 474.758 317.031 474.758 316.394C474.758 315.757 474.242 315.241 473.605 315.241C472.968 315.241 472.452 315.757 472.452 316.394C472.452 317.031 472.968 317.547 473.605 317.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73204 407.088H846.571V529.265L774.01 480.89L668.578 526.163L561.904 480.889L469.497 567.096L369.645 595.626L325.612 559.034L290.881 506.317L258.011 537.948L184.828 476.548L133.972 483.991L76.915 434.995L3.11304 416.39L3.73204 407.088Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M3.732 407.088V407.689H845.97V528.141L774.072 480.208L668.577 525.509L561.78 480.183L469.192 566.557L369.785 594.96L326.065 558.628L290.985 505.382L257.983 537.139L185.008 475.914L134.156 483.355L77.199 434.447L3.746 415.929L4.332 407.128L3.732 407.088V407.689V407.088L3.132 407.048L2.479 416.85L76.631 435.544L133.788 484.626L184.648 477.183L258.038 538.756L290.777 507.253L325.158 559.439L369.505 596.291L469.801 567.634L562.029 481.595L668.579 526.817L773.947 481.571L847.173 530.389V406.486H3.169L3.132 407.048L3.732 407.088Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M3.732 407.088V407.689H845.97V528.141L774.072 480.208L668.577 525.509L561.78 480.183L469.192 566.557L369.785 594.96L326.065 558.628L290.985 505.382L257.983 537.139L185.008 475.914L134.156 483.355L77.199 434.447L3.746 415.929L4.332 407.128L3.732 407.088ZM3.732 407.088V407.689V407.088ZM3.732 407.088L3.132 407.048L2.479 416.85L76.631 435.544L133.788 484.626L184.648 477.183L258.038 538.756L290.777 507.253L325.158 559.439L369.505 596.291L469.801 567.634L562.029 481.595L668.579 526.817L773.947 481.571L847.173 530.389V406.486H3.169L3.132 407.048L3.732 407.088Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalInjectionPump);
export default __webpack_public_path__ + "static/media/chemical-injection-pump.0f7f529ea033d52c53059a6b805164d1.svg";
export { ForwardRef as ReactComponent };